<template>
  <section class="lui-filelist auto-height">
    <!--判断预览模式-->
    <div
      id="list-wrapper"
      :class="!isListMode ? 'card-view' : 'list-view'"
      class="list-wrapper auto-height"
    >
      <!-- 列表头 -->
      <file-header
        v-if="switchMark"
        v-model="fileList.content"
        v-list-head-drag="listDragCb"
        :header-info="headerInfo"
        :sort-info="sortInfo"
        :list-mode="isListMode"
        :list-drag-styles="listDragStyles"
        :list-drage-styles-resize="listDrageStylesResize"
        :have-sort="headerInfo.haveBigSort"
        :is-disabled="isDisabled"
        :select-file="selectFile"
        @doSort="doSort"
      >
        <!--列表中有数据选中时，头部数据展示插槽-->
        <template
          v-if="$slots.operate"
          slot="operate"
        >
          <slot name="operate" />
        </template>
        <!--头部右侧操作按钮插槽, 大图模式排序默认存在排序按钮-->
        <template
          v-if="$slots.operView"
          slot="operView"
        >
          <slot name="operView" />
        </template>
      </file-header>

      <!--文件列表部分-->
      <div
        v-if="!nothing"
        id="scroll-wrapper"
        ref="scrollWrapper"
        class="scroll-wrapper"
        :class="[hasShowRight, isVirtualList ? 'virtual-wrapper' : '']"
        @scroll="rawLoadMore"
      >
        <!-- 非虚拟列表的 ie9 或者大图模式 -->
        <template v-if="!isVirtualList">
          <file-item-bg
            v-for="(currentData, index) in fileList.content"
            :key="currentData['uniqueKey' || 'neid']"
            :timer-data="timerData"
            :current-data="currentData"
            :is-list-mode="isListMode"
            :header-info="headerInfo"
            :index="index"
            :hover-neid="hoverNeid"
            :is-disabled="isDisabled"
            :show-more="showBigMore"
            :select-file="selectFile"
            @setHoverNeid="setHoverNeid"
            @itemClick="itemClick"
            @singleSelect="singleSelect"
            @CtrlAndClick="CtrlAndClick"
            @ShiftAndClick="ShiftAndClick"
            @singleNameSelect="singleNameSelect"
            @setPosition="setPosition"
          >
            <!--列表内部操作项的插槽-->
            <template
              slot="operation"
              slot-scope="{data}"
            >
              <slot
                name="operation"
                :data="data"
              />
            </template>
            <!--列表名称左侧图标插槽，例如病毒，收藏等-->
            <template
              slot="icongroup"
              slot-scope="{data}"
            >
              <slot
                name="icongroup"
                :data="data"
              />
            </template>
          </file-item-bg>
          <div
            v-if="canScroll && isEnding"
            class="is-end"
          >
            {{ $t('已到最后') }}
          </div>
        </template>

        <!-- 虚拟列表模式 -->
        <template v-else>
          <virtual-list
            id="virtual-scroll-wrapper"
            ref="virtual-list"
            :size="size"
            :remain="virtualRemain()"
            :onscroll="loadMore"
          >
            <file-item
              v-for="(currentData, index) in fileList.content"
              :key="currentData['uniqueKey' || 'neid']"
              :timer-data="timerData"
              :current-data="currentData"
              :is-list-mode="isListMode"
              :header-info="headerInfo"
              :list-drag-styles="listDragStyles"
              :list-drage-styles-resize="listDrageStylesResize"
              :file-item-icon-width-cache="fileItemIconWidthCacheComputed"
              :index="index"
              :hover-neid="hoverNeid"
              :is-disabled="isDisabled"
              :select-file="selectFile"
              @setHoverNeid="setHoverNeid"
              @itemClick="itemClick"
              @singleSelect="singleSelect"
              @CtrlAndClick="CtrlAndClick"
              @ShiftAndClick="ShiftAndClick"
              @singleNameSelect="singleNameSelect"
              @setPosition="setPosition"
            >
              <!--列表内部操作项的插槽  v-if="value[index] && value[index].length "-->
              <template
                v-if="tagContent[index] && showTag"
                slot="tag"
              >
                <tag-list :tag-info="tagContent[index]" />
              </template>
              <template
                slot="operation"
                slot-scope="{data}"
              >
                <slot
                  name="operation"
                  :data="data"
                />
              </template>
              <!--列表名称左侧图标插槽，例如病毒，收藏等-->
              <template
                slot="icongroup"
                slot-scope="{data}"
              >
                <slot
                  name="icongroup"
                  :data="data"
                />
              </template>
            </file-item>
            <div
              v-if="canScroll && isEnding"
              class="is-end"
            >
              {{ $t('已到最后') }}
            </div>
          </virtual-list>
        </template>
      </div>

      <!--加载loading-->
      <div
        v-show="this.fileList && isLoading"
        class="lui-wait"
      >
        <img
          src="../../../static/image/search-load.gif"
          alt="loading"
        >
      </div>

      <!--没有数据的插槽，暂不处理-->
      <slot
        v-if="showNothing"
        name="nothing"
      />
    </div>
  </section>
</template>
<script>

import extend from 'extend'
import { isInternetExplorer9 } from 'js/util/util.js'
import virtualList from 'vue-virtual-scroll-list' // 拖动特效组件
import TagList from 'components/common/tag-list/tag-list.vue'
import _$ from 'js/api/getdata.js'
import FileHeader from './components/file-header.vue' // 头部组件
import FileItem from './components/file-item.vue' // 列表中间内容组件
import FileItemBg from './components/file-item-bg.vue'
// 大图中间内容组件
export default {
  components: {
    FileHeader,
    FileItem,
    FileItemBg,
    virtualList,
    TagList,
  },
  props: {
    /**
         * 头部数据信息,list格式必须如下
         *  {   title: '文件名',             //名字
         *      name: 'name',               //key
         *      class: 'name-title',        //className
         *      drag: false,                //是否能拖拽
         *      sort: true,                 //是否显示排序图标
         *      sortStatus: 0,              //排序图标状态  0: 无状态; 1: 升序 2: 降序
         *      sortName: '文件名',         //用于排序入口中的名称展示
         *  }
         */
    headerInfo: {
      type: Object,
      default: (value) => extend(value, {
        list: [],
        checkbox: false, // 显示checkbox
        replaceAllHeaderInfo: false, // 全选的时候,是否隐藏头部数据,
        haveBigSort: true, // 显示大图排序方式
      }),
    },
    sortInfo: {
      type: Array,
      default: () => [],
    },
    // 文件列表数据
    fileList: {
      type: Object,
      default: (value) => extend(value, {
        content: [],
      }),
    },
    // 列表模式
    isListMode: {
      type: Boolean,
      default: true,
    },
    // 禁用checkbox点击
    isDisabled: Boolean,
    // 大图模式和列表模式下,头部数据的重新加载
    switchMark: Boolean,
    // 加载每一页数据前的loading
    isLoading: {
      type: Boolean,
      default: false,
    },
    // 大图模式显示更多按钮
    showBigMore: Boolean,
  },
  data() {
    return {
      tagContent: {}, // 标签
      listDragStyles: new Map(), // 关于列表拖动
      listDrageStylesResize: false, // 关于列表拖动
      fileItemIconWidthCache: 0, // 关于列表拖动
      hasShowRight: 'has-hide-right', // 现实右侧
      size: 52, // 每个列表项高度，在可变高度，此prop只用于计算容器视口外部的虚拟列表固定高度。
      canScroll: false, // 是否可以滚动
      noLoadMore: false, // 滚动加载更多
      timerData: { // 点击列表后发送请求的缓冲时间
        timer: null,
        timeStamp: 200,
      },
      hoverNeid: null, // 鼠标的hoverNeid
      lastSelectedData: null, // shift ctrl多选使用
      showNothing: false, // 显示没文件的时候图标
      selectFile: { // 选中的文件
        data: [], // 文件
        type() { // 选中文件的类型
          if (this.data.length > 1) return 'multi'
          if (this.data.length == 0) return ''
          return this.data[0].data.is_dir ? 'folder' : 'file'
        },
        selectedNeids: () => this.data.map((item) => item.data.neid),
        // 添加被选中的item数据
        selectedDataAdd(obj) {
          const { data } = this
          for (let i = 0; i < data.length; i++) {
            if (data[i].index == obj.index) {
              data[i] = obj
              return
            }
          }
          this.data.push(obj)
        },
        /**
                 * 删除指定选中的文件
                 */
        selectedDataDel(index) {
          const { data } = this
          for (let i = 0; i < data.length; i++) {
            if (data[i].index == index) data.splice(i, 1)
          }
        },
        /**
                 * 清空所有选中数据
                 */
        selectedDataClear() {
          this.data.splice(0, this.data.length)
        },
      },
    }
  },
  computed: {
    showTag() {
      return this.$route.name === 'ferry'
    },
    /**
         * 计算该文件下是否含有文件或文件夹
         */
    nothing() {
      return !this.fileList.content.length
    },
    /**
         * 是否加载完全部数据
         */
    isEnding() {
      // console.log('isEnding', this.fileList.content.length && (this.fileList.total_size === this.fileList.content.length))
      const end = this.fileList.content.length && (this.fileList.total_size === this.fileList.content.length)
      this.noLoadMore = !!end
      return end
    },
    /**
         * 判断是否为ie9
         */
    isIE9() {
      return isInternetExplorer9()
    },
    /** 判断是否为列表模式或者非ie9，ie9现在开启虚拟列表模式 */
    isVirtualList() {
      if (!this.isListMode) return false
      return true
    },
    /**
         * 注fileItemIconWidthCache的值变化，使文件名列宽度进行更改
         */
    fileItemIconWidthCacheComputed() {
      return this.fileItemIconWidthCache
    },
  },
  watch: {
    /**
         * 监听list列表数据是否发生变化
         */
    fileList(newVal, oldVal) {
      this.showNothing = !this.fileList.content.length
      if (this.$route.name === 'ferry') {
        this.init()
      }
    },
  },
  mounted() {
    // 添加监听屏幕变化事件
    window.addEventListener('resize', this.setResize)
  },
  updated() {
    // 大图模式和列表模式切换，需要正确获取canScroll状态
    this.$nextTick(() => {
      this.initCanScroll()
    })
  },
  methods: {
    init() {
      this.tagContent = {}
      const { content } = this.fileList
      const params = []
      content.forEach((el) => {
        params.push({ neid: el.neid, nsid: el.nsid })
      })
      _$.postData('extraMeta', { json: JSON.stringify(params) }).then(({ data, status }) => {
        if (status === 200) {
          this.tags = data.tags
          this.tags.forEach((el) => {
            this.fileList.content.forEach((e, index) => {
              if (el.neid === e.neid) {
                if (this.tagContent[index] === undefined) {
                  this.$set(this.tagContent, index, [])
                }
                // this.tagContent[index] = this.tagContent[index] || []
                this.tagContent[index].push(el)
              }
            })
          })
        }
      }).catch((error) => {
        this.showTips((error.response && error.response.data && error.response.data.message)
          || error.message, 'warn')
      })
    },
    /**
         * 拖拽列表宽度的方法
         */
    listDragCb(data, fileItemIconWidthCache) {
      if (data === 'resize') {
        this.listDragStyles = new Map()
        this.fileItemIconWidthCache = 0
        this.listDrageStylesResize = true
      } else {
        this.listDragStyles = data
        this.listDrageStylesResize = false
        if (fileItemIconWidthCache) { // 传入的改变后的宽度若有值，则会改变列表文件名列宽度，若没有值代表触发拖拽的不是文件名列，置0
          this.fileItemIconWidthCache = fileItemIconWidthCache
        } else {
          this.fileItemIconWidthCache = 0
        }
      }
    },
    /**
         * 虚拟列表模式走这个滚动
         */
    loadMore(e) {
      const target = e.target || e.srcElement
      if ((target.clientHeight + target.scrollTop) >= (target.scrollHeight - 50) && !this.noLoadMore) {
        this.noLoadMore = true
        this.$emit('loadMore')
      }
    },
    /** 大图和ie9模式走这个滚动 */
    rawLoadMore(e) {
      if (this.isIE9 || !this.isListMode) {
        this.loadMore(e)
      }
    },
    /**
         * 计算remain的值
         * 有多少项目应在虚拟列表视窗中显示，size和remain确定外容器视高(size × remian)。
         */
    virtualRemain() {
      const mode = localStorage.getItem('Mode') || 'list'
      if (mode === 'icon') { // 大图模式
        if (this.hasShowRight) { // 开启了右边栏
          return 30
        }
        return 60
      }
      return 15
    },
    /**
         * 初始化滚动组件
         */
    initCanScroll() {
      this.$nextTick(function () { // 等渲染后拿scrollheight
        const sd = document.querySelector('#virtual-scroll-wrapper') || document.querySelector('#scroll-wrapper')
        const sh = sd && sd.scrollHeight
        const ch = sd && sd.clientHeight
        if (ch < sh) {
          this.canScroll = true
        } else {
          this.canScroll = false
        }
      })
    },
    /** 列表点击事件 */
    itemClick(data) {
      this.$emit('itemClick', data)
    },
    /** 头部组件排序 */
    doSort(data) {
      this.noLoadMore = false // 设置为可以再次滚动加载
      this.$emit('doSort', data)
    },
    /**
         * 设置鼠标的hoverNeid
         */
    setHoverNeid(data) {
      this.hoverNeid = data.neid
      // 抛出hover事件
      this.$emit('itemHover', data)
    },
    // +++++++++++++++++++++待优化的鼠标选中事件+++++++++++++++++++++++++++++
    /**
         *取消指定文件的选中
         */
    unselected(index, data) {
      data.checked = false
      this.selectFile.selectedDataDel(index)
    },
    /**
         * 选中指定文件
         */
    selected(index, data) {
      // 判断当前文件有没有下载权限，没有下载权限不触发选中
      data.checked = true
      this.selectFile.selectedDataAdd({ index, data })
    },
    /**
         * 清空所有的选中
         */
    clearSelect() {
      const content = [...this.fileList.content]
      content.forEach((item) => {
        item.checked = false
      })
      this.fileList.content = content
      this.selectFile.selectedDataClear()
    },
    /**
         * 根据当前点击文件状态取反
         */
    select({ index, currentData }) {
      !currentData.checked
        ? this.selected(index, currentData)
        : this.unselected(index, currentData)
    },
    /**
         * 记录最后选中的文件
         */
    setLastSelectedData(index, data) {
      this.lastSelectedData = { index, data }
    },
    /**
         * 点击列表的选中操作
         */
    singleSelect({ index, currentData }) {
      // 该文件为选中状态且选中文件数量为0或1
      if (currentData.checked && this.selectFile.data.length <= 1) {
        this.select({ index, currentData })
      } else {
        this.clearSelect() // 清除选中的文件数量
        this.selected(index, currentData) // 选中当前点击文件
      }
      // 记录最后选中的文件
      this.setLastSelectedData(index, currentData)
    },
    /**
         * 按住ctrl和点击鼠标左键的操作
         */
    CtrlAndClick({ index, currentData }) {
      // 选中文件
      this.select({ index, currentData })
      // 记录最后选中的文件
      if (currentData.checked) {
        this.setLastSelectedData(index, currentData)
      }
    },
    /**
         * 按住shift和点击鼠标左键的操作
         */
    ShiftAndClick({ index, currentData }) {
      // 如果还没有选中的文件(即最后选的一个文件为null),选中该文件，并设置为最后一个
      if (this.lastSelectedData === null) {
        this.select({ index, currentData })
        this.setLastSelectedData(index, currentData)
      } else {
        // 取选中值和最后一个文件的最小值和最大值
        const start = Math.min(index, this.lastSelectedData.index)
        const end = Math.max(index, this.lastSelectedData.index)
        // 循环如果index在该范围内，则设置为选中，否则设置为非选中
        this.fileList.content.forEach((item, i) => {
          if (i >= start && i <= end) {
            this.selected(i, item)
          } else {
            this.unselected(i, item)
          }
        })
      }
    },
    /**
         * 点击文件名称，选中该文件，并触发itemClick事件
         */
    singleNameSelect({ index, currentData }) {
      if (!currentData.checked) {
        // 清楚所有选中
        this.clearSelect()
        // 选中指定文件
        this.selected(index, currentData)
      }
      // 设置最后选中的文件
      this.setLastSelectedData(index, currentData)
    },
    /**
         * 右键抛出列表显示位置事件
         */
    setPosition(data) {
      this.$emit('setPosition', data)
    },
  },
}
</script>

<style lang="less">
@import "~less/file.less";
//整个列表的布局
.lui-filelist {
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-bottom:80px;

  .list-wrapper {
    overflow: hidden;
    height: 100%;
    padding-bottom: 40px;
    box-sizing: border-box;
    position: relative;
    //列表部分
    .scroll-wrapper {
      height: 100%;
      box-sizing: border-box;
      overflow-x: hidden;
      overflow-y: auto;
      position: relative;
      &.virtual-wrapper{
        overflow-y: hidden;
        #virtual-scroll-wrapper {
          height: 100%!important;
          position: relative;
          overflow-x: hidden;
          &#new-file-box{
            height: unset!important;
          }
          &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          &::-webkit-scrollbar-thumb {
            opacity: 0.6;
            background: #C1C7CD;
            border-radius: 100px;
          }
        }
      }
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }
      &::-webkit-scrollbar-thumb {
        opacity: 0.6;
        background: #C1C7CD;
        border-radius: 100px;
      }
      &#new-file-box{
        height: unset!important;
      }

      //到最后的样式
      .is-end {
        float: left;
        width: 100%;
        line-height: 30px;
        font-size: 12px;
        color: #C3C3C4;
        text-align: center;
        // csshack
        // chrome edge ff
        @media screen and (-webkit-min-device-pixel-ratio:0) {
          padding-bottom:0;
        }
        //only edge
        @supports (-ms-ime-align:auto) {
          padding-bottom: 21px;
        }
        //only firefox
        @-moz-document url-prefix() {
          padding-bottom: 21px;
        }
      }
    }
  }
  .list-wrapper.list-view {
    .filelist-item-inner {
      /**操作项目部分 */
      .file-operate {
        position: relative;
        //right: 10px;
        float: left;
        line-height: 20px;
        top: 16px;
        //width: 30%;
        min-width: 153px;
        //margin-left: 6px;
        & > span {
          float: left;
          margin: 0 6px;
          border: 1px solid #C6CDD7;
          border-radius: 2px;
          cursor: pointer;
          width: 30px;
          height: 30px;
          box-sizing: border-box;
          text-align: center;
          line-height: 28px;
          position: relative;
          &:first-child{
            margin: 0 6px 0 4px;
          }
          &.link{
            width: 48px;
          }
          // 分享下拉菜单的样式
          .file-delivery-options, .file-operate-options{
            li{
              text-align: left;
            }
          }
          &:hover,
          &.hover {
            background: #FFFFFF;
            border: 1px solid @gray;
            .icon::before {
              color: @gray;
            }
          }
        }
        .icon {
          line-height: 18px;
          &::before {
            font-size: 20px;
            color: @lightGray;
          }
          /*&.icon-i-more::before {*/
          /*    font-size: 21px;*/
          /*}*/
        }
        .icon-new {
          display: inline-block;
          width: 20px;
          height: 20px;
          vertical-align: middle;
          //background: url(~image/file-list/edit.svg) no-repeat;
          cursor: pointer;
        }
        .icon-auth{
          display: inline-block;
          width: 20px;
          height: 20px;
          vertical-align: middle;
          //background: url("~image/common/icon20x20.png") no-repeat;
          cursor: pointer;
        }
        .icon-auth-edit{
          background-position: -80px -61px;
        }
        .icon-auth-delete{
          background-position: -60px -60px;
        }
        .icon-i-rmfavorite{
          display: inline-block;
          width: 16px;
          height: 16px;
          margin: 2px;
          vertical-align: middle;
          //background: url("~image/favorite/delete_favorite.svg") no-repeat;
          cursor: pointer;
          &:hover{
            //background-image:url("~image/favorite/delete_favorite_active.svg");
          }
        }
        ul.file-delivery-options{
          position: absolute;
          border: 1px solid #C6CDD7;
          background-color: #fff;
          background-image: linear-gradient(rgba(255, 255, 255, .5), rgba(255, 255, 255, 0));
          border-radius: 2px;
          box-shadow: 0 1px 6px rgba(0, 0, 0, .4), 0 1px 0 rgba(255, 255, 255, .5) inset;
          line-height: 20px;
          // 用来加点击空白处的mask
          z-index: 12;
          // z-index: 10;
          color: #7d7d7d;
          padding-top: 8px;
          padding-bottom: 8px;
        }
        ul.file-operate-options{
          position: absolute;
          left: 32px;
          margin: 0;
          list-style-type: none;
          z-index: 1000;
          min-width: 190px;
          background: #FFFFFF;
          border: 1px solid #E8EBEF;
          box-shadow: 0 4px 14px 0 rgba(5,15,40,0.10);
          border-radius: 2px;
          padding: 8px 0;
          &.show-menu{
            display: block;
          }
          li.menu-item {
            min-width: 158px;
            padding: 10px 16px;
            color: #282e3d;
            cursor: pointer;
            box-sizing: border-box;
            line-height: 16px;
            &#auth,
            &#history,
            &#delete, &#favorite {
              border-top: 1px solid #EAEAEA
            }
            &#favorite::after, &#share-option::after {
              content: '';
              display: block;
              float: right;
              width: 5px;
              height: 8px;
              margin-top: 5px;
              //background: url('~image/favoriteBox/more.svg') no-repeat;
            }
            &:hover,
            &#favorite.hover{
              background: #F6F7FA;
            }
          }
          li:first-child{
            border-top: none!important;
          }
          hr{
            height:1px;
            border:none;
            border-top:1px solid #eee;
          }
        }
        // 更多分享样式
        ul.file-delivery-options{
          width: 248px;
          background: #FFFFFF;
          border: 1px solid #E0E3E9;
          box-shadow: 0 4px 14px 0 rgba(5,15,40,0.10);
          border-radius: 2px;
          position: absolute;
          padding: 8px 0;
          color: #4D5365;

        }

      }
      /**传入的外部样式 */
      .nowrap {
        display: inline-block;
        position: relative;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .filelist-icon {
        width: 60%;
        font-size: 14px;
        min-width: 210px;
        .nowrap();
      }
      .update-date-updator {
        width: 28%;
        min-width: 150px;
        text-indent: 4px;
        overflow: hidden;
        font-family: "Arial","PingFangSC-Regular", "microsoft yahei", "微软雅黑", "Hiragino Sans GB";
        .nowrap();
      }
      .update-size {
        width: 10%;
        min-width: 60px;
        text-indent: 4px;
        overflow: hidden;
        font-family: "Arial","PingFangSC-Regular", "microsoft yahei", "微软雅黑", "Hiragino Sans GB";
        .nowrap();
      }

      /**列表响应式部分 */
      @media only screen and (max-width: 1392px) {
        .filelist-icon {
          width: 60%;
          min-width: 210px;
        }
        .update-date-updator {
          width: 28%;
          min-width: 120px;
        }
        .update-size {
          width: 10%;
          min-width: 60px;
        }
      }
      @media only screen and (max-width: 1309px) {
        .filelist-icon {
          width: 60%;
          min-width: 210px;
        }
        .update-date-updator {
          width: 27%;
          min-width: 120px;
        }
        .update-size {
          width: 10%;
          min-width: 60px;
        }
      }

      @media only screen and (max-width: 1260px) {
        .filelist-icon {
          width: 55%;
          min-width: 160px;
        }
        .update-date-updator {
          width: 30%;
          min-width: 120px;
        }
        .update-size {
          width: 15%;
          min-width: 60px;
        }
      }
      @media only screen and (max-width: 1160px) {
        .filelist-icon {
          width: 50%;
          min-width: 160px;
        }
        .update-date-updator {
          width: 32%;
          min-width: 150px;
        }
        .update-size {
          width: 15%;
          min-width: 60px;
        }
      }
      @media only screen and (max-width: 1080px) {
        .filelist-icon {
          width: 44%;
          min-width: 160px;
        }
        .update-date-updator {
          width: 32%;
          min-width: 150px;
        }
        .update-size {
          width: 15%;
          min-width: 60px;
        }
      }

    }
  }

}
/**loading的样式 */
.lui-wait {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999999;
  img {
    width: 50px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -32px;
    margin-top: -32px;
  }
}
/**不知道作用 */
#new-file {
  .file-area{
    padding-left: 35px;
  }
  .file-icon{
    width: 27px;
    height: 27px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
  .card-mode{
    text-align: center;
    height: 230px;
    .file-icon {
      background-color: transparent;
      background-repeat: no-repeat;
      height: 80px;
      margin: 35px calc(50% - 40px);
      vertical-align: middle;
      width: 80px;
    }
  }
  input {
    width: 380px;
    height: 15px;
    line-height: 15px;
    border: 1px solid #0A64FA;
    border-radius: 2px;
    text-indent: 8px;
    padding: 5px 0 5px 0;
  }
  .icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    //background: url('~image/common/icon20x20.png') no-repeat;
    cursor: pointer;
  }
  span.sure {
    background-position: -133px -316px;
    text-indent: -999em;
    margin: 0 5px;
  }
  span.cancel {
    background-position: -160px -316px;
    text-indent: -999em;
  }
}
.drag-upload-mask {
  // width: 100%;
  // height: 100%;
  position: absolute;
  background: rgba(255,255,255,0.50);
  border: 3px dashed #3B83FB;
  z-index: 8000;
  opacity: 0.5;
  top: 0;
  right:0;
  left:0;
  bottom:0;
  text-align: center;
  font-size: 28px;
  color: #637282;
  letter-spacing: 2px;
}
.drag-upload-mask-client{
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 8000;
  top: 0;
}
/**更多图标微调 */
.icon-i-more {
  background-position: -4px!important;
}
/**响应式 */
@media only screen and (max-width: 1380px) and (min-width: 1280px){
  .card-view .has-hide-right .isfolder-true{
    .file-absolute {
      left: 165px!important;
    }
    .update-date-updator {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
// ie9hack
@ie9:~'\0';
@media screen and (min-width:0@ie9) and (min-resolution:.001dpcm) {
  .lui-filelist .list-wrapper .scroll-wrapper{
    overflow-y: auto!important;
  }
  .lui-filelist .list-wrapper .scroll-wrapper > div{
    height: auto!important;
  }
}
</style>
